import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';
import { EmployeeService } from 'src/app/pages/employee/services/employee.service';

@Component({
  selector: 'app-reject-all-benefits-modal',
  templateUrl: './reject-all-benefits-modal.component.html',
  styleUrls: ['./reject-all-benefits-modal.component.css']
})
export class RejectAllBenefitsModalComponent implements OnInit {
  @Input() data: any[];
  portalSettings: any;
  formData: { [key: string]: any } = {};
  rejectionText: string;
  showDeclineType: boolean;
  declineList: any[];
  @ViewChild('declineForm', { static: false }) declineForm: NgForm;

  constructor(private ngbActiveModal: NgbActiveModal, private portalSettingsService: PortalSettingsService, private employeeService: EmployeeService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.rejectionText = this.portalSettings.Step3RejectionText.ConfigValue != null ? this.portalSettings.Step3RejectionText.ConfigValue.replace("target=\"\"", "target=\"_blank\"") : "";
    this.showDeclineType = this.portalSettings.BNDeclineComboBoxName.ConfigValue != null && this.portalSettings.BNDeclineComboBoxName.ConfigValue != "" ? true : false;
    this.getVistaOptions();
    this.formData.selectedDecline = null;
  }

  getVistaOptions() {
    this.employeeService.getVistaOptions("benefitdeclinereason").then((response: any) => {
      this.declineList = response;
    });
  }
  
  declineClicked() {
    this.ngbActiveModal.close(this.formData);
  }

  cancelClicked() {
    this.ngbActiveModal.dismiss();
  }
}
